export const REDIRECT_SPECIAL_IDS = new Set(['game_result', 'game_prizes']);

export const REDIRECT_TOKEN_REGEX =
  /(?:data-redirect=(?:"|\\")([a-zA-Z0-9_+/=-]+)(?:"|\\")|#(?:spin_)?redirect_([a-zA-Z0-9_+/=-]+))/g;

export const extractRedirectEncodedIds = (...sources: Array<string | undefined | null>): string[] => {
  const ids = new Set<string>();

  sources.forEach((source) => {
    if (!source) return;
    const matches = [...source.matchAll(REDIRECT_TOKEN_REGEX)];
    matches.forEach((match) => {
      const encoded = match[1] || match[2];
      if (encoded) {
        ids.add(encoded);
      }
    });
  });

  return Array.from(ids);
};

export const countRedirectReferences = (source: string | undefined | null, encoded: string): number => {
  if (!source || !encoded) return 0;
  return [...source.matchAll(REDIRECT_TOKEN_REGEX)]
    .filter((match) => (match[1] || match[2]) === encoded).length;
};

export const decodeRedirectTemplateId = (encoded: string): number | null => {
  if (!encoded || REDIRECT_SPECIAL_IDS.has(encoded)) {
    return null;
  }

  try {
    const decoded = atob(encoded);
    const id = Number(decoded);
    if (!Number.isNaN(id) && id > 0) {
      return id;
    }
  } catch {
    return null;
  }

  return null;
};

export const remapRedirectTokens = (
  content: string,
  mapping: Record<string, string>,
): string => {
  if (!content || !Object.keys(mapping).length) {
    return content;
  }

  let updatedContent = content.replace(
    /(#(?:spin_)?redirect_)([a-zA-Z0-9_+/=-]+)/g,
    (fullMatch, prefix: string, encoded: string) => {
      const nextEncoded = mapping[encoded];
      if (!nextEncoded) {
        return fullMatch;
      }
      return `${prefix}${nextEncoded}`;
    },
  );

  updatedContent = updatedContent.replace(
    /(data-redirect=(?:"|\\")?)([a-zA-Z0-9_+/=-]+)((?:"|\\")?)/g,
    (fullMatch, prefix: string, encoded: string, suffix: string) => {
      const nextEncoded = mapping[encoded];
      if (!nextEncoded) {
        return fullMatch;
      }
      return `${prefix}${nextEncoded}${suffix}`;
    },
  );

  return updatedContent;
};
